module.exports = __webpack_public_path__ + "static/media/ic-berpengalaman.3b9c17fb.svg";